module.exports = __webpack_public_path__ + "img/card-background.d971038c.png";